import { Routes } from "../../src/config/routes";
const contactEnData = [
  {
    title: "About moverii",
    desc: [
      {
        title: "What does moverii offer?",
        desc:
          "moverii lets you discover and book your active dream vacation! \n" +
          "\n" +
          "<br/>" +
          "Be it camping or luxury, relaxation or adventure, martial arts or yoga - with more than 1000 journeys on our platform, we offer a huge choice that makes it easier than ever to find the sports & active journey that suits you and your desires! \n",
      },
      {
        title: "How does moverii work?",
        desc:
          "We work together with professional hosts of sports & active journeys all over the world to offer a diverse selection of journeys. Your hosts are people who have made their passion their profession and offer you an unforgettable experience with their knowledge of the respective sport and the environment!\n" +
          "\n" +
          "<br/><br/>" +
          "To ensure the quality of your journey, we carefully select your hosts and only work with partners who have been rated at least 4.5 out of 5 stars by independent travelers.\n" +
          "\n" +
          "<br/><br />" +
          "Planning your journey is as simple as child's play: discover our diverse selection and book the sports & active journey that suits you and your wishes! After your booking you can find all important information about your journey in your account and can communicate with your host via our platform. This way you can fully concentrate on the experience: Your active dream vacation!\n",
      },
      {
        title: "Who is behind moverii?",
        desc:
          "We love what we do! This is our simple secret.\n" +
          "\n" +
          "<br/><br />" +
          "We, that's Adrian and Daniel, two brothers from the Rhine region in Germany, who have always shared a common passion: The combination of journeys and sports!\n" +
          "\n" +
          "<br/><br />" +
          "It all started with a desperate search from the sofa. Today, we together with our team are proud to offer you a great selection for your active dream vacation! The variety is huge, the planning is easy and the quality is guaranteed. This way you can fully concentrate on your experience and don't end up on the sofa in despair like we did. Find out more about us here: " +
          "\n" +
          "" +
          '<a class="contact-hyperlink" href="/about-us">About moverii</a>.',
      },
    ],
  },
  {
    title: "Sports & Active Travel",
    desc: [
      {
        title: "What do we mean by sports & activity travel?",
        desc:
          "Simply put, sports & active journeys offer experiences where you enjoy a guided sports / activity program in a beautiful place in this world. \n" +
          "\n" +
          "<br/><br />" +
          "But for us, sports & active travels is much more than that! For us it is the special way of traveling. You are not the classic tourist. Rather, you meet like-minded people in a natural way, experience nature in a completely different, much more intense way and together with your hosts immerse yourself in the local culture. \n" +
          "\n" +
          "<br/><br />" +
          "What exactly this means and how exactly your sports & activity trip looks like is up to you: be it camping or luxury, tranquility or adventure, martial arts or yoga, our selection is large and you are guaranteed to find the sports & active journey that suits you and your individual wishes!\n",
      },
      {
        title: "What do sports & active journeys with moverii include?",
        desc:
          "Our sports & active journeys include at least the accommodation and the sports activities . The sports activities always take place under professional guidance of trainers / teachers. Depending on the journey, other services such as meals, joint excursions, wellness treatments or airport transfers may also be included.\n" +
          "\n" +
          "<br/><br />" +
          'A detailed list of all services included in the price can be found in the detailed travel description in the section "Included in the price" of each journey:\n' +
          "\n" +
          "\n" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/included-en.jpg" alt="Included services" />',
      },
      {
        title: "For whom are sports & activity trips with moverii suitable?",
        desc:
          "A sports & activity trip with moverii is suitable for you if you...\n" +
          "\n" +
          "<br/>" +
          "... want to experience your vacation actively\n" +
          "<br/>" +
          "... want to discover nature and travel consciously\n" +
          "<br/>" +
          "... want to make tourism more sustainable\n" +
          "<br/>" +
          "... are open for new people and cultures\n" +
          "<br/>" +
          "... don't want to worry about quality or organization\n" +
          "<br/>" +
          "\n" +
          "\n" +
          "\n" +
          "<br/><br/>" +
          "How old you are, with whom you travel and how fit you are, is secondary: We offer you a large and varied selection of sports & active journeys, so that everyone can find the right experience for their individual requirements and wishes! Because after all: Sport & active travelling can be an unforgettable experience for anyone in the world! \n",
      },
      {
        title: "Who organizes the trips / Who are the hosts of the trips?",
        desc:
          "The hosts of the trips are professional providers of sports & active journeys in the respective countries. They are people who have made their passion their profession. This passion in combination with the experience and knowledge of the respective sport and the environment of your destination enable you to have an unforgettable experience!\n" +
          "\n" +
          "<br/><br />" +
          "In order to guarantee the quality of our trips, we carefully select the hosts together with our network of sports experts and travelers. We only work with hosts who have been rated by independent travelers with at least 4.5 out of 5 stars!\n" +
          "\n" +
          "<br/><br />" +
          "For us it is very important to support local suppliers on fair conditions and avoid mass tourism or club vacations. This supports the local economy and creates individual experiences for eternity.\n",
      },
      {
        title: "What does quality-checked travel mean?",
        desc:
          "Not everyone can become a host on moverii! In order to be able to offer a sports & active journey on moverii, hosts have to fulfill various requirements. The main focus is on reviews from other, independent travelers. For us, the experiences of travelers are the most important and central quality feature. If other travelers rate the sports & activity trip with at least 4.5 out of 5 stars and recommend it, we also feel comfortable recommending the trip to you!\n" +
          "\n" +
          "<br/><br />" +
          "Besides the experiences of independent travelers, we have met a lot of hosts ourselves and visited many of the sites ourselves. Even though it would be our dream to really visit all the journeys we offer ourselves, this is simply not possible. Therefore, we cooperate with experts from different sports and use this knowledge and their network to expand our selection of trips day by day and to find new hosts of the best sports & active journeys for you!\n",
      },
      {
        title:
          "Are there trainers / teachers for the sports & activity program?",
        desc:
          "The sports & activity program on moverii journeys is always led by qualified trainers / teachers. We are convinced that a trainer who is passionate about what he or she does is a decisive factor for an unforgettable travel experience. Passionate and qualified trainers respond to you individually and whether your goal is to calm down, reach the next level or just have fun, with the right trainer you will succeed playfully and with a smile on your lips.\n" +
          "\n" +
          "<br/><br />" +
          "You can see who the trainers/teachers are on the different trips, what qualifications they have and what philosophy they follow on the page of the journey under the section Hosts:\n" +
          '<br/><img src="https://api.moverii.de/cdn/statics/contact_help/moverii-team.jpg" alt="Moverii Team"/>',
      },
      {
        title: "What equipment do I need for a journey?",
        desc:
          "For a sports & active journey on moverii you do not need any special equipment. For most of the journeys, the sports equipment is included in the price and you will be provided with everything on site.\n" +
          "\n" +
          "<br/><br />" +
          "There are exceptions, typically for those experienced in a sport where it is assumed that you have the necessary equipment yourself. (For example, a mouth guard for an advanced Muay Thai camp or a surfboard for a surfari for experienced surfers). In case you don't have the necessary equipment, you can always book it for an extra charge or buy it on the spot.\n" +
          "\n" +
          "<br/><br />" +
          'You can find out if the sports equipment is included in the price of your chosen trip in the section "Sports & Activity Program" as well as in the overview "Included in the price":\n' +
          '<br/><img src="https://api.moverii.de/cdn/statics/contact_help/included-en.jpg" alt="Sports equipment included in the price"/>',
      },
      {
        title: "What previous experience do I need to participate?",
        desc:
          "You don't need to have any prior knowledge or experience with the respective sport for a sports & activity trip. On moverii you will find journeys that are suitable for all levels as well as journeys that are especially suitable for beginners, advanced or experienced athletes.\n" +
          "\n" +
          "<br/><br />" +
          "To find just those journeys that fit your level, you can simply use the filter 'previous knowledge' on the searching page: \n" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/level-filter-en.jpg" alt="Suchseite Filter Vorkenntnisse"/>' +
          "\n" +
          "<br/><br />" +
          "For each journey, you will find the information for which level the offer is suitable, both in the facts about the journey and in the description of the sports & activity program:" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/level-facts-en.jpg" alt="Fakten zu der Reise"/>',
      },
      {
        title: "How fit do I need to be for a sports & active journey?",
        desc:
          "Your fitness level does not matter for a sports & active journey. Just as with the previous knowledge, you will find journeys that are suitable for people who have never done any sports in their life or only very little, as well as journeys where a certain fitness level is required.\n" +
          "\n" +
          "<br/><br />" +
          "If a certain fitness level is a prerequisite for the trip, you will find the explanation in the description of the sports & activity program. If you are unsure whether you are fit enough for the trip, you can simply write a short message to the host(s) and they will be happy to assist you with an appropriate assessment:\n" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/contact-host-en.png" alt="Chat / Contakt Host"/>',
      },
      {
        title:
          "I am traveling alone. Is a sports & active journey right for me?",
        desc:
          "Sports & active journeys are the perfect choice if you are traveling alone! Instead of sitting alone on the beach somewhere or sightseeing in the city, you'll meet like-minded people in a casual atmosphere. By choosing to travel actively, you'll automatically share similar interests and quickly build a bond. Through the shared activities and experiences, you'll quickly get to know each other better and grow together as a group. With a sports & active journey, you won't feel alone, but on the contrary, you will quickly feel comfortable and meet new friends!\n" +
          "\n" +
          "<br/><br />" +
          "To see only journeysthat are suitable for solo travelers, you can simply use the filter \n" +
          "\n" +
          "\n" +
          "\n" +
          "<br/>" +
          "On moverii, you can find journeys suitable for couples, groups, friends and families. However, the majority of travelers who book a sports & active journey on moverii travel alone. Therefore, if you are traveling alone, a sports & active journey is just the right thing for you: Instead of squatting alone on the beach somewhere or sightseeing in the city, you'll meet like-minded people in an informal atmosphere. By doing activities together, you'll quickly bond and it's anything but difficult or strange to meet new people. You can easily find out whether an offer is suitable for solo travelers in the FAQs of the respective trip under the point \"For whom is the trip suitable\".\n",
      },
      {
        title: "Are sport & activity trips always a group?",
        desc:
          "On a sports & active journey you always meet new people! The nice thing is that the atmosphere is not forced: If you have found the right journey, you will naturally meet like-minded people. It is not uncommon for long-lasting friendships to develop during a sports journey.\n" +
          "\n" +
          "<br/><br />" +
          "The intensity of the togetherness varies from trip to trip: On moverii you will find trips where you spend your vacation together with a fixed group, as well as trips where you do sports in a group, but otherwise can organize your time by yourself. This way, you decide for yourself how distinctive the social program and the togetherness in the group should be.\n" +
          "\n" +
          "<br/><br />" +
          "The size of the groups depends on the trip. However, we always make sure that the sports & activity program takes place in smaller groups, so that the trainers / teachers can respond to you individually and a pleasant atmosphere is created.\n",
      },
      {
        title: "Can I bring my pet?",
        desc: "Dogs are loyal companions and always by your side. Also a sport & activity trip can be an even more beautiful experience with your own dog. Whether it is allowed to bring your own dog depends on the trip and the host. To see only trips where you can bring your dog, you can simply use the appropriate filter 'Suitable for solo travelers':",
      },
    ],
  },
  {
    title: "Search, find, book",
    desc: [
      {
        title: "How do I find the right sports & activity trip?",
        desc:
          "With moverii you can find the right sports & activity trip for your individual wishes and needs as easy as ever before! We recommend you to narrow down your search results with our filter options to get the right selection displayed right away. \n" +
          "\n" +
          "<br/><br />" +
          "The following options are available as filters:\n" +
          "\n" +
          '<ol class="list-disc mx-10 my-4">' +
          "<li>Sports </li>" +
          "<li>Categories within the sports </li> " +
          "<li>Previous experience - your previous experience in the particular sport </li>" +
          "<li>Destinations - from continents to regions and places</li>" +
          "<li>Period - from specific dates to whole months</li>" +
          "<li Cancellation policy - only trips with 100% refund </li>" +
          " <li>Suitable for - trips for single travelers, couples, groups, friends or families</li> " +
          "<li>Environment - trips to nature, sea, mountains or city </li> " +
          "<li> Accommodation - from camping to luxury, the right accommodation for your sport & activity trip</li> " +
          "<li>Meals - from trips where meals are included to dietary requirements such as vegan, vegetarian or common allergies/intolerances </li> " +
          "<li>Price per night - set your budget for your sports & activity trip</li>" +
          "</ol>" +
          "\n" +
          "\n" +
          "<br/>" +
          "You can find the different filters on the left side of the search page. Just click on the checkboxes of the filter options that suit you and are important to you, and you will be shown the matching trips. \n" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/filter-en.png" alt="filter search page\n"/>' +
          "The alternative to the filter options is our TripFinder. When you start the TripFinder, you will be guided through the most relevant questions about your sports & activity trip and receive suitable recommendations at the end. This way you can easily find the sports & activity trip that suits you and your wishes!" +
          `<a class="contact-hyperlink" href="${Routes.tripfinder}"> Click here to go to TripFinder.</a> `,
      },
      {
        title: "What is the TripFinder?",
        desc:
          "With the TripFinder you can easily find the sports & active trip that suits you and your wishes! \n" +
          "\n" +
          "<br/><br />" +
          "Just answer the important questions about your ideas and general conditions with a few clicks and you will receive suitable recommendations for your active dream vacation. Just try it out for yourself: To the TripFinder\n",
      },
      {
        title: "How do I book my trip?",
        desc:
          "For trips on moverii, we distinguish between instant bookings and booking requests. \n" +
          "\n" +
          "<br/><br />" +
          "<strong> Instant bookings</strong> are trips where you can see the current availabilities live and accordingly book your vacation immediately on the desired dates.\n" +
          "\n" +
          "<br/><br />" +
          "For <strong>booking requests</strong>, the availabilities are not up to date, but must first be confirmed by the host. \n" +
          "\n" +
          "<br/><br />" +
          "You can always tell if a trip is an instant booking or a booking request by the button on the right side of the trip description.\n" +
          "\n" +
          "<br/><br />" +
          "<h2> Procedure for instant bookings </h2>\n" +
          "\n" +
          "<br/><br />" +
          'If it is an instant booking, the text on the button will read "To booking":\n' +
          "\n" +
          "<br />" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/book-1-en.jpg" alt="Booking Button" />\n' +
          "\n" +
          "<br/><br />" +
          "To book a trip with the instant booking option, simply follow these steps:\n" +
          "\n" +
          "<br/>" +
          '<ol class="list-decimal mx-10 my-4">' +
          '<li> In the box on the right, select your desired travel period and the number of guests and click on the button "To book".</li> \n' +
          "<li>Now you will see the accommodation options that are available for the period you want for the number of guests you have selected. Just choose the accommodation that appeals to you the most.</li> \n" +
          "<li>If the trips offer optional services, you can add them to your booking in the next step.</li>\n" +
          "<li>In the last step you enter your data and have the possibility to choose between different payment methods.</li> \n" +
          "<li>With your payment your booking is confirmed and you will receive your booking confirmation by email as well as directly in your moverii account.</li> \n" +
          "<li>Our tip: If you create a moverii account, you will receive a welcome message from your host(s) in addition to your booking confirmation and have access to other useful information about your vacation, such as a packing list and travel information.</li>\n" +
          "</ol>" +
          "<br/>" +
          "<strong>Procedure for booking requests</strong>" +
          'If it is a booking request, the text on the button will read "Reserve":\n' +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/book-2-en.jpg" alt="Reservieren Button"/>' +
          "" +
          '<ol class="list-decimal mx-10 my-4">' +
          '<li> In the box on the right, select your desired travel period and the number of guests and click on the button "To book".</li> \n' +
          "<li>Now you will see the accommodation options that are available for the period you want for the number of guests you have selected. Just choose the accommodation that appeals to you the most.</li> \n" +
          "<li>If the trips offer optional services, you can add them to your booking in the next step.</li>\n" +
          "<li>In the last step you enter your data and have the possibility to choose between different payment methods.</li> \n" +
          "<li>You will always receive a response to your booking request within 24 hours. If hosts can confirm your booking request, the trip is automatically reserved for you.</li> \n" +
          "<li>To confirm the reservation, you can choose between different payment methods. As soon as we have received your payment, you will receive your booking confirmation by email as well as directly in your moverii account. </li> \n" +
          "<li>Our tip: If you create a moverii account, you will receive a welcome message from your host(s) in addition to your booking confirmation and have access to other useful information about your vacation, such as a packing list and travel information.</li>\n" +
          "</ol>" +
          "",
      },
      {
        title: "How do I get in touch with hosts?",
        desc:
          'To contact the hosts of the trips, you can simply click on the button "Contact host" in the box on the right side:\n' +
          "\n" +
          "<br/>" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/contact-host-1-en.png" class="my-10" alt="host contact button"/>\n' +
          "Then a window will open where you can write a message with your questions and wishes to the host: \n" +
          "\n" +
          "<br/>" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/contact-host-2-en.png" class="my-10" alt="pop-up contact request"/> \n' +
          "\n" +
          "\n" +
          "<br/>" +
          'If you already know when and with whom you want to travel, you also have the option to specify your desired travel period, the number of travelers and your preferred room category. To do this, simply click on the checkbox "I already know when and with whom I want to travel":\n' +
          "\n" +
          "\n" +
          "<br/>" +
          ' <img src="https://api.moverii.de/cdn/statics/contact_help/contact-host-3-en.png" class="my-10" alt="pop-up contact request with opened"/>\n' +
          "\n" +
          "You will usually receive an answer from the host within 24 hours.\n",
      },
      {
        title: "Can I reserve trips?",
        desc:
          "For booking requests, the trip is automatically reserved for you after confirmation of availability by the host. Usually the reservation is valid for 48 hours. \n" +
          "\n" +
          "<br/><br />" +
          "The minimum duration of a reservation is 24 hours. This shorter time of the reservation can come up with short term requests, when it comes to the last places. \n" +
          "\n" +
          "<br/>" +
          "If you are not too spontaneous in your vacation planning, hosts are also happy to reserve your trip for you for longer. For this you can simply contact the host. \n" +
          "\n" +
          "<br/><br />" +
          'How long the trip is reserved for you, you can always see in the email with the confirmation and a moverii account under the menu item "Your trips".\n',
      },
      {
        title: "How do I see the availability of the trips?",
        desc:
          "For trips on moverii, we distinguish between instant bookings and booking requests. \n" +
          "\n" +
          "<br/><br />" +
          'Instant bookings are trips where you can see the current availability live. Simply enter your desired period and the number of travelers in the box on the right side of the travel description and click on the button "To book". You will then see the available accommodation options for your desired period and can immediately book your vacation on the desired dates.\n' +
          "\n" +
          "<br/><br />" +
          'For booking requests, the availability is not up to date, but must first be confirmed by the host. For this you can simply make a booking request. Simply enter your desired period and the number of travelers in the box on the right side of the travel description and click on the button "Book". You can then select your desired accommodation option and add optional services to your booking request. You will receive a response to your booking request within 24 hours. If your desired trip is no longer available in this form, you will receive suitable alternative suggestions from us as well as from the host(s).',
      },
      {
        title: "Can I customize the trip duration?",
        desc:
          "Trips on moverii follow a holistic approach and always consist of at least the combination of accommodation and the sports & activity program. Many trips also include other services, such as meals, other activities or joint excursions. The various experiences often build on each other, resulting in travel packages with a specific duration.\n" +
          "\n" +
          "<br/><br />" +
          "The exact duration varies from trip to trip and depends on the experience and the program. Some trips also offer several options to choose from. You can always see the respective options in the facts about the trip:\n" +
          "\n" +
          "\n" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/duration.jpg" alt="customize the trip duration"/>\n' +
          "\n" +
          "<br/><br />" +
          "If you wish to travel for a different period than the one indicated, you can always contact the hosts and tell them your desired travel period. In many cases, hosts can make you an individual offer. \n" +
          "\n" +
          "<br/><br />" +
          "You can find more information about the travel duration and how flexible it can be in the FAQs of the respective trips.\n",
      },
      {
        title: "Can I add / remove services?",
        desc: "When traveling on moverii, at least the accommodation and the sports & activity program are always included as services in the price. Depending on the trip, other services such as meals, other activities or joint excursions may also be included in the price. In addition, you have the possibility to book optional services for many trips. If you have individual wishes, you can simply contact the hosts and they will do their best to create an individual offer for you.",
      },
      {
        title: "Booking confirmation and travel information",
        desc:
          "Once you have confirmed your booking, you will receive your booking confirmation in pdf format both by email and in your moverii account for download. The booking confirmation contains all the important data of your trip, as well as the data of the travelers and an overview of the services included in the price.\n" +
          "\n" +
          "<br/><br />" +
          'Along with your booking confirmation, you will receive a welcome message from your host:in with all the important information about your trip. You can access this message at any time in your moverii account under the menu item "My trips". Here you will also find more information, such as a packing list, details about your arrival and check-in times. If you have any further questions, your hosts will be happy to answer your welcome message and are always available to help. \n' +
          "\n" +
          "<br/><br />" +
          "If you have any general questions or requests, you can always contact your moverii team and send us a message. We will answer you within a few hours, guaranteed.\n",
      },
    ],
  },
  {
    title: "Arrival and meals",
    desc: [
      {
        title: "Can I book my travel through moverii?",
        desc:
          "With a few exceptions, you are responsible for your own travel to and from moverii. The exception are a few trips within Europe. \n" +
          "\n" +
          "<br/><br />" +
          'You can always find information on how to get there in the "Getting there" section of the trip description. Here you will also find tips on how to get to your destination. \n' +
          "\n" +
          "<br/><br />" +
          "In addition, many hosts offer an airport transfer, which is either already included in the travel package or can be booked as an option.\n" +
          "\n" +
          "<br/><br />" +
          "Generally, we recommend Skyscanner for the search for suitable flights. If you want to travel by train or bus, you can find the right offer at Trainline.\n",
      },
      {
        title: "Are there transfers from the airport / train station?",
        desc:
          "Many tours offer a transfer from the airport or train station. Sometimes these are already included in the travel package or can be booked as an alternative.\n" +
          "\n" +
          "<br/><br />" +
          "If no transfer is offered, your host will be happy to give you tips on the best way or contact a shuttle service.\n" +
          "\n" +
          "<br/><br />" +
          'Before you book, you will always find information on how to get there in the "How to get there" section of the trip description. Once you have booked your trip, you can find more information in your moverii account under the menu item "My trips".\n',
      },
      {
        title: "How do I recognize my driver:in for airport transfers?",
        desc: 'If you have booked a transfer for your trip, you will receive a booking confirmation, a welcome message from your host and further information about your trip. This includes detailed information about your arrival and airport transfer. You can find this information in your moverii account under the menu item "My travels".',
      },
      {
        title: "What are the check-in and check-out times?",
        desc: 'Check-in and check-out times vary from trip to trip. You can find the relevant information in the FAQs of the trip description as well as in your moverii account under the menu item "My trips" after your booking. In addition to the check-in and check-out times, you can also see here whether you can arrive earlier, store your luggage and use the common areas.',
      },
      {
        title: "Is catering included in the price?",
        desc:
          "Whether food is included in the travel package varies from trip to trip: On moverii you can find trips that include full meals as well as trips that include breakfast. Still other trips offer you the possibility to book the meals as an option. If you prefer to cook yourself, moverii also offers trips without meals, but with a kitchen that you can use. Be it a shared kitchen or your own kitchen in an apartment. \n" +
          "\n" +
          "<br/><br />" +
          'If you want your trip to include meals, you can easily narrow down your search results with the filter options "Full board" / "Breakfast included". \n' +
          "\n" +
          "<br/><br />" +
          'You can always find out whether meals are included in the travel package and how they are arranged in the "Meals" section of the respective travel descriptions. \n' +
          "\n" +
          "<br/><br />" +
          'Your hosts will be happy to take dietary requirements and allergies into consideration! Please indicate them in your booking. In addition, you have the possibility to filter your search for the right trip according to your dietary requirements. Simply use the filters "Vegetarian", "Vegan", "Raw food", "Lactose-free" and "Gluten-free".\n',
      },
      {
        title: "Are there trips with vegan / vegetarian meals?",
        desc:
          'Most trips include vegetarian and vegan meals. To be on the safe side, you can simply click on the filter "Vegetarian" and / or "Vegan" in the catering category when searching for the right trip and only trips with vegetarian and / or vegan catering will be displayed.\n' +
          "\n" +
          "<br/><br />" +
          'If the meals are included in the travel package, your dietary requirements are usually already requested when booking. Alternatively, you can always use the box "Your wishes" in the last step of your booking.\n',
      },
      {
        title: "What can I do if I have special dietary needs or allergies?",
        desc:
          'Depending on how specific your dietary requirements are, you can already narrow down your selection when searching for the right trip. Simply use the filters "Vegetarian", "Vegan", "Raw food", "Lactose-free" and "Gluten-free" in the category "Catering".\n' +
          "\n" +
          "<br/><br />" +
          'If you have more specific dietary requirements, you can simply specify them in the box "Your wishes" in the last step of your booking. Alternatively, you can simply write a message to your host.\n',
      },
    ],
  },
  {
    title: "Payment",
    desc: [
      {
        title: "What payment methods do I have to choose from?",
        desc:
          "One advantage of booking a trip with moverii is that you can pay securely online. You can decide whether to pay the full amount at the time of booking or to make a deposit first. \n" +
          "\n" +
          "<br/><br />" +
          "In the case of a deposit, 25% of the total amount is due at the time of booking. We ask you to pay the remaining 75% up to 30 days before departure. \n" +
          "\n" +
          "<br/><br />" +
          "Whether you choose to pay in full or make a deposit - balance payment, the following payment methods are available to you: \n" +
          "\n" +
          "\n" +
          "<br/>" +
          "Credit or debit card (VISA, Mastercard, Maestro, American Express, JCB, Discover and Bancontact)\n" +
          '<ul class="list-disc mx-10 my-4">' +
          '<li><span class="text-2xl">&#8226;</span> PayPal</li> \n' +
          '<li><span class="text-2xl">&#8226;</span> GooglePay</li> \n' +
          '<li><span class="text-2xl">&#8226;</span> ApplePay</li> \n' +
          '<li><span class="text-2xl">&#8226;</span> Klarna</li> \n' +
          '<li><span class="text-2xl">&#8226;</span> Instant bank transfer</li> \n' +
          "</ul>",
      },
      {
        title: "How does the deposit - balance payment work?",
        desc:
          "If you decide to make a deposit - balance payment when making your booking, you will initially pay only 25% of the total amount to confirm your booking. \n" +
          "\n" +
          "<br/><br />" +
          "The remaining 75% of the total amount we ask you to pay until 30 days before departure. You will receive a separate email with your invoice and the possibility to pay it with your chosen payment method.\n",
      },
      {
        title: "What is behind the best price guarantee?",
        desc:
          "We guarantee you the best price on all our trips! This means that you can't book the same trip cheaper anywhere else. \n" +
          "\n" +
          "<br/><br />" +
          "If you find the exact same trip for the identical dates cheaper on another website, we will refund you the difference! Just send us a message with a screenshot. Special discount promotions from other websites are excluded.\n",
      },
      {
        title: "What can I do if I have problems with the payment?",
        desc:
          "If you encounter problems paying for your trip, please try the following first:\n" +
          "\n" +
          "<br/>" +
          '<ol class="list-disc mx-10 my-4">' +
          "<li>Double check that you have entered all your payment details correctly and try again.</li> \n" +
          "<li>If you are trying to pay with a credit or debit card, please make sure that your card is authorized for both international and online purchases. You can either check this in your online banking settings or contact your bank directly.</li> \n" +
          "<li>If no error message was displayed, try using a different browser.</li>  \n" +
          "<li>If you still have problems making your payment, please choose another payment method.</li> \n" +
          "\n" +
          "\n" +
          "</ol>" +
          "<br/><br />" +
          "If you get stuck on your own and can't make the payment, feel free to drop us a message with your problem and we'll find a solution together:\n" +
          "\n" +
          "<br/>" +
          "Integration contact form (name, email address, optional phone number, message)\n",
      },
      {
        title: "Can I buy a gift voucher?",
        desc:
          "With a gift voucher for moverii you give experiences for eternity! To buy a gift certificate, you can simply proceed as follows:\n" +
          "\n" +
          '<ol class="list-decimal mx-10 my-4">' +
          "<li>Go to the following website: moverii gift vouchers</li> \n" +
          "<li> Choose your preferred design</li>\n" +
          "<li>Customize your gift certificate with a personal text</li> \n" +
          "<li>Choose the amount you want to give away </li> \n" +
          "<li>Decide if you want to print the gift voucher and give it away or if you want it to be sent by email on a specific date</li> \n" +
          "<li>Make your payment and put a smile on the face of your loved ones</li> \n" +
          "</ol>" +
          "\n" +
          "\n" +
          "<br/><br />" +
          "In principle, gift vouchers can be redeemed for all trips on moverii. There is also no expiration date when the gift certificate expires.\n" +
          'You can find all information about our gift voucher, as well as how to purchase it, here: <a href="https://moverii.de/voucher">To moverii gift voucher</a>\n',
      },
      {
        title: "How do I redeem a gift certificate?",
        desc: 'Every moverii voucher contains a code. To redeem your voucher, simply start the booking process for your desired trip and enter your voucher code in the last step under "Redeem voucher". Afterwards, the value of the voucher will be automatically deducted from the total amount.',
      },
    ],
  },
  {
    title: "Cancellation",
    desc: [
      {
        title: "What are the cancellation policies for travel on moverii?",
        desc:
          "For the cancellation conditions on moverii we have defined four uniform levels and sorted all trips on our website into these four levels. This way we can offer you maximum transparency and you can cancel most of the trips without giving any reason. \n" +
          "\n" +
          "<br/><br />" +
          "Here are the four levels of our cancellation policy:\n" +
          "\n" +
          "<br/>" +
          "<strong> Very flexible </strong>\n" +
          '<ol class="list-disc m-4 ml-10">' +
          "<li>100% refund of the total amount in case of cancellation up to 7 or more days before the start of the trip.</li> \n" +
          "<li>No refund in case of cancellation 6 days or more before the start of the trip</li> \n" +
          "</ol>" +
          "\n" +
          "\n" +
          "<br/><br />" +
          "<strong>Flexible </strong> \n" +
          "<br/>" +
          '<ol class="list-disc m-4 ml-10">' +
          " <li>100% refund of the total amount in case of cancellation up to 30 or more days before the start of the trip</li> \n" +
          "<li>50% refund of the total amount in case of cancellation between 15-29 days before the start of the trip </li> \n" +
          "<li>No refund in case of cancellation 14 days or more before the start of the trip</li> \n" +
          "</ol>" +
          "\n" +
          "\n" +
          "<br/><br />" +
          "<strong>Moderate </strong> \n" +
          "<br/>" +
          '<ol class="list-disc m-4 ml-10">' +
          "<li>100% refund of the total amount in case of cancellation up to 60 or more days before the start of the trip </li> \n" +
          "<li>  50% refund of the total amount in case of cancellation between 30-59 days before the start of the trip</li>\n" +
          "<li>No refund in case of cancellation 29 days or more before the start of the trip </li> \n" +
          "</ol>" +
          "\n" +
          "\n" +
          "<br/><br />" +
          "<strong>Individual</strong> \n" +
          '<ol class="list-disc m-4 ml-10">' +
          "<li> Individual means that the cancellation conditions are set by the hosts themselves, as it is unfortunately not entirely possible for us to find a suitable level for all trips. However, individual cancellation conditions are the exception and still easily understandable.</li> \n" +
          "</ol>" +
          "\n" +
          "<br/><br />" +
          "You can always see which level applies to each trip in the trip description in the facts about the trip:\n" +
          "\n" +
          "<br/><br />" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/cancel-1.png" alt="facts about the trip" /> \n' +
          "\n" +
          "<br/><br />" +
          'If you only want to see trips with (very) flexible cancellation conditions, you can simply use the corresponding filter "Cancellation conditions" in your search.\n' +
          "\n" +
          "<br/><br />" +
          'More information about our cancellation policy can be found here: <a href="https://www.moverii.de/content/cancellation">Cancellation policy at moverii</a> \n' +
          "\n" +
          "<br/><br />" +
          'All trips with (very) flexible cancellation conditions can be found here: <a href="https://moverii.de/s/moverii?page=1&cancel[]=1">Go to all trips with (very) flexible cancellation conditions</a>\n',
      },
      {
        title: "Can I change my trip to another date?",
        desc:
          "In addition to a cancellation, many trips on moverii also give you the option to rebook your vacation for a later date. The rebooking can in many cases be made much later than the cancellation with full refund. \n" +
          "\n" +
          "<br/><br />" +
          "Whether and until when you can rebook a trip free of charge, you can always see in the facts about the trip:\n" +
          "\n" +
          "\n" +
          "<br/>" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/date-change.jpg" alt="facts about the trip - pop-up cancellation conditions" class="my-5" />' +
          "\n" +
          "<br/>" +
          "If you want to change your trip, you can simply write a message to your hosts.\n",
      },
      {
        title: "How do I cancel my booking?",
        desc:
          "If you want to cancel your booking, you can easily do it in your moverii account. Proceed as follows:\n" +
          "\n" +
          "<br/>" +
          '<ol class="list-decimal mx-10 my-4">' +
          '<li>Click on "My trips" in the menu and you will get to the overview page of your booking.</li> \n' +
          '<li> In the section "Overview of your trip" you will find the item "Cancellation conditions". Click here on "Learn more".</li> \n' +
          "<li>Now a pop-up will open, in which you will get a detailed list of the amount that will be refunded and until when.  </li> \n" +
          '<li> If you finally decide to cancel the trip, click on the button "Cancel now" and the booking will be automatically canceled and the refund will be issued. </li> \n' +
          "<li> In the last step you will receive a cancellation confirmation and the refundable amount will be credited back to your chosen payment method within a few days.</li> \n" +
          "</ol>" +
          "<br/><br />" +
          ".\n" +
          "\n" +
          "Our tip: Before you cancel a trip, you can always contact the hosts in advance. In many cases you can find a better solution together.\n",
      },
      {
        title:
          "When will I receive my cancellation confirmation and refund of the amount due?",
        desc:
          "When you cancel your booking, you will immediately receive your cancellation confirmation. The refund will also be issued automatically at that moment. \n" +
          "\n" +
          "<br/><br />" +
          "The refund is always made automatically with the same payment method that you have chosen for your booking. Depending on this, the refund will arrive either immediately or within a maximum of 3 business days. So you don't have to do anything else.\n",
      },
      {
        title: "Do I need travel insurance for a sports/activity trip?\n",
        desc:
          "So that you can enjoy your vacation to the fullest and without any worries, we recommend you an appropriate travel protection. \n" +
          "\n" +
          "<br/><br />" +
          "First and foremost, we recommend an international health insurance, so that you receive the best possible treatment in case of emergency without having to bear immense costs yourself. \n" +
          "\n" +
          "<br/><br />" +
          "We also recommend that you take out travel cancellation and travel interruption insurance. This way you will be comprehensively covered regardless of the cancellation conditions and you will always receive a 100% refund of all costs, even at short notice and on site. This applies not only to Corona-related circumstances, but also to many other reasons, such as other illnesses, serious accidents, loss of employment and much more. \n" +
          "\n" +
          "<br/><br />" +
          'To make your life as easy as possible when looking for the best travel protection, we work together with Travelsecure, the multiple test winner of Stiftung Warentest. All information about Travelsecure and the possibility to purchase your travel insurance can be found here: Your travel insurance with <a href="https://rechner.travelsecure.de/schnellerfassung/default.aspx?partnerid=1-8-4975">Travelsecure</a>\n',
      },
    ],
  },
];
const contactDeData = [
  {
    title: "Über moverii\n",
    desc: [
      {
        title: "Was bietet moverii an?",
        desc:
          "Mit moverii findest du deinen aktiven Traumurlaub! \n" +
          "<br/><br />" +
          "Von Camping bis Luxus, von Ruhe bis Abenteuer, von Kampfsport bis Yoga - die Vielfalt ist riesengroß und du findest so einfach wie nie zuvor die Sport- & Aktivreise, die zu dir und deinen Wünschen passt! \n",
      },
      {
        title: "Wie funktioniert moverii?",
        desc:
          "Mit moverii findest du so einfach wie nie zuvor deinen aktiven Traumurlaub! Dafür arbeiten wir mit professionellen Gastgeber:innen von Sport- & Aktivreisen überall auf der Welt zusammen.\n" +
          "\n" +
          "<br/><br />" +
          "Hinter deinen Gastgeber:innen stehen Menschen, die ihre Leidenschaft zu ihrem Beruf gemacht haben und dir mit ihrem Wissen über die jeweilige Sportart und die Umgebung ein unvergessliches Erlebnis bieten!\n" +
          "\n" +
          "<br/><br />" +
          "Damit die Qualität deiner Reise gesichert ist, wählen wir deine Gastgeber:innen sorgfältig aus und arbeiten nur mit Partnern zusammen, die von unabhängigen Reisenden mit mindestens 4,5 von 5 Sternen bewertet sind.\n" +
          "\n" +
          "<br/><br />" +
          "Für dich ist die Planung deiner Reise kinderleicht: Entdecke unsere vielfältige Auswahl und buche die Sport- & Aktivreise, die zu dir und deinen Wünschen passt! In deinem Konto findest du anschließend alle wichtigen Informationen rund um deinen Urlaub auf einen Blick und kannst direkt Kontakt zu deinen Gastgeber:innen aufnehmen. So kannst du dich voll und ganz auf das Erlebnis konzentrieren: Deinen aktiven Traumurlaub!\n",
      },
      {
        title: "Wer steckt hinter moverii?",
        desc:
          "Wir lieben was wir tun! Das ist unser einfaches Geheimnis. \n" +
          "\n" +
          "<br/><br />" +
          "Wir, das sind Adrian und Daniel, zwei Brüder aus dem Rheinland, die schon immer eine gemeinsame Leidenschaft teilen: Die Verbindung aus Reisen und Sport! \n" +
          "\n" +
          "<br/><br />" +
          "Angefangen hat alles mit einer verzweifelten Suche vom Sofa aus. Heute sind wir stolz, dir gemeinsam mit unserem Team deinen aktiven Traumurlaub ermöglichen zu können! Die Vielfalt ist dabei riesengroß, die Planung kinderleicht und die Qualität garantiert. So kannst du dich voll auf dein Erlebnis konzentrieren und endest nicht wie wir verzweifelt auf dem Sofa. Mehr über uns erfährst du hier: " +
          '<a class="contact-hyperlink" href="/about-us" class="font-bold">Über moverii</a>',
      },
    ],
  },
  {
    title: "Sport- & Aktivreisen",
    desc: [
      {
        title: "Was verstehen wir unter Sport- & Aktivreisen?",
        desc:
          "Einfach gesagt sind Sport- & Aktivreisen ein Urlaub, bei dem du an einem wunderschönen Ort auf dieser Welt ein geführtes Sport- / Aktivprogramm erlebst. \n" +
          "\n" +
          "<br/><br />" +
          "Für uns sind Sport- & Aktivreisen jedoch viel mehr als das! Für uns ist es die besondere Art zu Reisen. Du bist nicht der/die klassische Tourist:in. Vielmehr triffst du auf ganz natürliche Weise Gleichgesinnte, erlebst durch die sportlichen Aktivitäten die Natur auf eine ganz andere, viel intensivere Art und tauchst gemeinsam mit deinen Gastgeber:innen in die lokale Kultur ein. \n" +
          "\n" +
          "<br/><br />" +
          "Was genau das bedeutet und wie genau deine Sport- & Aktivreise aussieht, liegt ganz bei dir: Von Camping bis Luxus, von Ruhe bis Abenteuer, von Kampfsport bis Yoga, unsere Auswahl ist groß und du findest garantiert die Sport- & Aktivreise, die zu dir und deinen individuellen Wünschen passt!\n",
      },
      {
        // this
        title: "Was beinhalten Sport- & Aktivreisen mit moverii?\n",
        desc:
          "Bei unseren Sport- & Aktivreisen sind mindestens die Unterkunft und die Sportaktivitäten in deinem Reisepaket und damit auch im Preis enthalten. Die Sportaktivitäten finden dabei immer unter professioneller Anleitung von Trainer:innen / Lehrer:innen statt. Je nach Reise sind weitere Leistungen, wie zum Beispiel die Verpflegung, gemeinsame Ausflüge, Wellness-Behandlungen oder der Flughafentransfer, inklusive.\n" +
          "\n" +
          "<br/><br />" +
          "Eine detaillierte Auflistung aller im Preis enthaltenen Leistungen, findest du in der detaillierten Reisebeschreibung im Abschnitt “Im Preis enthalten”.\n" +
          "\n" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/included-de.jpg" alt="Included services" />',
      },
      {
        title: "Für wen eignen sich Sport- & Aktivreisen mit moverii?",
        desc:
          "Eine Sport- & Aktivreise mit moverii passt zu dir, wenn du…\n" +
          "\n" +
          "<br/>" +
          "... deinen Urlaub aktiv erleben willst\n" +
          "... die Natur entdecken und bewusst reisen willst\n" +
          "... Tourismus nachhaltiger machen willst\n" +
          "... offen für neue Menschen und Kulturen bist\n" +
          "... dir keine Sorgen um die Qualität oder Organisation machen willst\n" +
          "\n" +
          "<br/><br />" +
          "Wie alt du bist, mit wem du verreist und wie fit du bist, ist dabei zweitrangig: Wir bieten dir eine große und vielfältige Auswahl an Sport- & Aktivreisen, sodass jede:r die passende Reise für die individuellen Voraussetzungen und Wünsche findet! Denn grundsätzlich gilt: Sport- & Aktivreisen können für jeden Menschen dieser Welt zu einem unvergesslichen Erlebnis werden! \n",
      },
      {
        title: "Wer veranstaltet die Reisen?\n",
        desc:
          "Die Gastgeber:innen der Reisen sind professionelle Anbieter:innen von Sport- & Aktivreisen in den jeweiligen Ländern vor Ort. Dahinter stehen Menschen, die ihre Leidenschaft zu ihrem Beruf gemacht haben. Diese Leidenschaft in Verbindung mit der Erfahrung und dem Wissen über die jeweilige Sportart und die Umgebung deines Reisezieles ermöglichen dir ein unvergessliches Erlebnis!\n" +
          "\n" +
          "<br/><br />" +
          "Damit wir bei unseren Reisen für Qualität garantieren können, wählen wir die Gastgeber:innen gemeinsam mit unserem Netzwerk aus Sportexperten und Vielreisenden sorgfältig aus. Dabei arbeiten wir nur mit Gastgeber:innen zusammen, die von unabhängigen Reisenden mit mindestens 4,5 von 5 Sternen bewertet sind!\n" +
          "\n" +
          "<br/><br />" +
          "Grundsätzlich legen wir viel Wert darauf, lokale Anbieter:innen zu fairen Bedingungen zu unterstützen und Massentourismus oder Cluburlaube zu meiden. So fördern wir die lokale Wirtschaft vor Ort und schaffen individuelle Erlebnisse für die Ewigkeit.\n",
      },
      {
        title: "Was bedeutet qualitätsgeprüfte Reisen?\n",
        desc:
          "Nicht alle können Gastgeber:innen auf moverii werden! Um eine Sport- & Aktivreise auf moverii anbieten zu können, müssen Gastgeber:innen verschiedene Anforderungen erfüllen. Im Zentrum stehen dabei insbesondere Bewertungen von anderen, unabhängigen Reisenden. Denn für uns sind die Erfahrungen und Erlebnisse der Reisenden das wichtigste und zentralste Qualitätsmerkmal. Wenn andere Reisende die Sport- & Aktivreise mit mindestens 4,5 von 5 Sternen bewerten und diese uneingeschränkt weiterempfehlen, fühlen auch wir uns wohl damit, dir die Reise zu empfehlen!\n" +
          "\n" +
          "<br/><br />" +
          "Neben den Erfahrungen unabhängiger Reisenden, haben wir selber schon viel gesehen und viele der Reisen selbst besucht. Auch wenn es unser Traum wäre, wirklich alle Reisen selbst zu besuchen, ist das leider einfach nicht möglich. Daher kooperieren wir mit Expert:innen aus den verschiedenen Sportarten und nutzen dieses Wissen und deren Netzwerk, um unsere Auswahl an Reisen Tag für Tag zu erweitern und neue Gastgeber:innen der besten Sport- & Aktivreisen für dich zu finden!\n",
      },
      {
        title:
          "Gibt es Trainer:innen / Lehrer:innen für das Sport- & Aktivprogramm?\n",
        desc:
          "Das Sport- & Aktivprogramm bei Reisen mit moverii wird immer von qualifizierten Trainer:innen / Lehrer:innen angeleitet. Wir sind der Überzeugung, dass ein:e Trainer:in / Lehrer:in, die mit Leidenschaft bei der Sache ist, ein entscheidender Faktor für eine unvergessliche Sport- & Aktivreise ist. Sie gehen individuell auf dich ein und ganz gleich ob dein Ziel ist, zur Ruhe zu kommen, das nächste Level zu erreichen oder einfach nur Spaß zu haben, mit dem/der richtigen Trainer:in / Lehrer:in gelingt das spielerisch und mit einem Lächeln auf den Lippen.\n" +
          "\n" +
          "<br/><br />" +
          "Wer die Trainer:innen / Lehrer:innen bei den verschiedenen Reisen sind, über welche Qualifikationen sie verfügen und welche Philosophie sie verfolgen, siehst du in der Reisebeschreibung unter dem Abschnitt ‘Gastgeber:in’:\n" +
          "",
      },
      {
        title: "Welche Ausrüstung benötige ich für eine Sport-/ Aktivreise?\n",
        desc:
          "Für eine Sport- & Aktivreise mit moverii benötigst du keine spezielle Ausrüstung. Bei dem Großteil der Reisen ist die Sportausrüstung im Preis enthalten und du kriegst vor Ort alles zur Verfügung gestellt.\n" +
          "\n" +
          "<br/><br />" +
          "Ausnahmefälle können Sportreisen für Fortgeschrittene sein, bei denen davon ausgegangen wird, dass du selber über die notwendige Ausrüstung verfügst. (Beispielsweise ein Mundschutz bei einem Muay Thai Camp für Fortgeschrittene oder ein Surfbrett bei einer Surfari für erfahrene Surfer:innen). Für den Fall, dass du nicht über die notwendige Ausrüstung verfügst, kannst du diese immer gegen einen Aufpreis dazu buchen oder vor Ort erwerben.\n" +
          "\n" +
          "<br/><br />" +
          "Ob die Sportausrüstung bei der von dir ausgewählten Reise im Preis enthalten ist, erfährst du sowohl in dem Abschnitt “Sport- & Aktivprogramm”, als auch in der Übersicht “Im Preis enthalten”:\n" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/included-de.jpg" alt="Screenshot Sports equipment included in the price"/>' +
          "<br/>" +
          "Damit du gut vorbereitet bist und weißt, was du für deine Reise einpacken musst, findest du in deinem moverii Konto unter ‘Meine Reisen’ eine Übersicht mit allen wichtigen Informationen zu deiner Reise. Darunter ist auch eine Packliste.",
        // '<img src="" alt="Screenshot Meine Buchungen Packliste"/>',
      },

      {
        title:
          "Wie viel Vorerfahrung benötige ich für die Teilnahme? / Welche Vorkenntnisse benötige ich für die Teilnahme?",
        desc:
          "Grundsätzlich musst du für eine Sport- & Aktivreise keine Vorkenntnisse oder Erfahrungen mit der jeweiligen Sportart haben. Du findest auf moverii sowohl Reisen, die für alle Level geeignet sind, als auch Reisen, die speziell für Anfänger, Fortgeschrittene oder erfahrene Sportler:innen geeignet sind.\n" +
          "\n" +
          "<br/><br />" +
          "Um direkt zu den Reisen zu gelangen, die zu deinen Vorkenntnissen passt, kannst du einfach den Filter ‘Vorkenntnisse’ nutzen. So werden dir ausschließlich Reisen angezeigt, die zu deinem Level und deinen Vorerfahrungen passen:\n" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/level-filter-de.jpg" alt="Screenshot Suchseite Filter Vorkenntnisse"/>' +
          "\n" +
          "<br/>" +
          "Bei den einzelnen Reisen findest du die Information, für welches Level das Angebot geeignet ist, sowohl in den Fakten zu der Reise als auch in der Beschreibung zum Sport- & Aktivprogramm:" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/level-facts-de.jpg" alt="Screenshot Fakten zu der Reise"/>',
      },
      {
        title: "Wie fit muss ich für eine Sport- & Aktivreise sein?",
        desc:
          "Grundsätzlich spielt dein Fitnesslevel für eine Sport- & Aktivreise erstmal keine Rolle. Genau wie bei den Vorkenntnissen findest du auch hier Reisen, die sich für Menschen eignen, die in ihrem Leben noch nie oder nur sehr wenig Sport gemacht haben, als auch Reisen, wo ein gewisses Fitnesslevel vorausgesetzt wird.\n" +
          "\n" +
          "<br/><br />" +
          "Wenn ein gewisses Fitnesslevel eine Grundvoraussetzung für die Reise ist, findest du die Erklärung dazu in der Beschreibung zum Sport- & Aktivprogramm. Wenn du dir unsicher bist, ob du fit genug für die Reise bist, kannst du dem/der Gastgeber:in einfach eine kurze Nachricht schreiben und sie stehen dir gerne mit einer entsprechenden Einschätzung zur Seite:\n" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/contact-host-de.png" alt="Screenshot Chat / Kontakt Host"/>',
      },
      {
        title:
          "Ich reise alleine. Ist eine Sport- & Aktivreise das Richtige für mich?",
        desc:
          "Sport- & Aktivreisen sind die perfekte Wahl, wenn du alleine reist! Anstatt irgendwo alleine am Strand zu hocken oder Sightseeing in der Stadt zu machen, triffst du in ungezwungener Atmosphäre auf Gleichgesinnte. Durch die Wahl der Reise teilt ihr automatisch ähnliche Interessen und baut schnell eine Verbindung auf. Durch die gemeinsamen Aktivitäten und Erlebnisse lernt ihr euch schnell besser kennen und wachst als Gruppe zusammen. Mit einer Sport- & Aktivreise wirst du dich nicht alleine fühlen, sondern im Gegenteil: Du wirst dich schnell wohlfühlen und neue Freund:innen treffen!" +
          "\n" +
          "<br/><br />" +
          "\n" +
          "\n" +
          "\n" +
          "\n" +
          "Um nur Reisen angezeigt zu bekommen, die sich für Alleinreisende eignen, kannst du einfach den Filter ‘Geeignet für Alleinreisende’ anklicken. In der Reisebeschreibung selber kannst du einfach in den FAQs unter dem Punkt “Für wen ist die Reise geeignet” nachschauen.\n",
      },
      {
        title: "Wie fit muss ich für eine Sport- & Aktivreise sein?",
        desc:
          "Grundsätzlich spielt dein Fitnesslevel für eine Sport- & Aktivreise erstmal keine Rolle. Genau wie bei den Vorkenntnissen findest du auch hier Reisen, die sich für Menschen eignen, die in ihrem Leben noch nie oder nur sehr wenig Sport gemacht haben, als auch Reisen, bei denen ein gewisses Fitnesslevel vorausgesetzt wird." +
          "\n" +
          "<br/><br />" +
          "\n" +
          "\n" +
          "Wenn ein gewisses Fitnesslevel eine Grundvoraussetzung für die Reise ist, findest du die Erklärung dazu in der Beschreibung zum Sport- & Aktivprogramm. Wenn du dir unsicher bist, ob du fit genug für die Reise bist, kannst du dem/der Gastgeber:in einfach eine kurze Nachricht schreiben und sie stehen dir gerne mit einer entsprechenden Einschätzung zur Seite:",
      },
      {
        title: "Finden Sport- & Aktivreisen immer eine Gruppe statt?",
        desc:
          "Bei einer Sport- & Aktivreise lernst du immer neue Menschen kennen! Das schöne dabei ist, dass die Atmosphäre nicht gezwungen ist: Wenn du die passende Sport- & Aktivreise für dich gefunden hast, triffst du ganz natürlich auf Gleichgesinnte mit denselben Interessen und Bedürfnissen. Nicht selten entstehen bei einer Sportreise sogar langjährige Freundschaften.\n" +
          "\n" +
          "<br/><br />" +
          "Die Intensität des Zusammenseins variiert von Reise zu Reise: Du findest auf moverii sowohl Reisen, bei denen du deinen Urlaub gemeinsam mit einer festen Gruppe verbringst, als auch Reisen, bei denen du in einer Gruppe Sport machst, sonst aber deinen Urlaub individuell gestalten kannst. Somit entscheidest du selber, wie ausgeprägt das Rahmenprogramm und das Zusammensein in der Gruppe sein soll.\n" +
          "\n" +
          "<br/><br />" +
          "Wie groß die Gruppen sind, hängt von der jeweiligen Reise ab. Wir legen jedoch bei allen Reisen großen Wert darauf, dass das Sport- & Aktivprogramm in kleinen Gruppen stattfindet, damit die Trainer:innen / Lehrer:innen individuell auf dich eingehen können und eine angenehme Atmosphäre kreiert wird.\n",
      },
      {
        title: "Kann ich meinen Hund mitbringen?",
        desc: "Hunde sind treue Wegbegleiter und immer an deiner Seite. Auch eine Sport- & Aktivreise kann ein noch schöneres Erlebnis mit dem eigenen Hund sein. Ob es gestattet ist, den eigenen Hund mitzubringen, ist abhängig von der Reise und den Gastgeber:innen. Um nur Reisen angezeigt zu bekommen, bei denen du deinen Hund mitbringen kannst, kannst du einfach den entsprechenden Filter ‘Geeignet für Alleinreisende’ nutzen:",
        // '<img src="" alt="Screenshot search page filter solo travelers\n" />',
      },
    ],
  },
  {
    title: "Suchen, finden, buchen",
    desc: [
      {
        title: "Wie finde ich die passende Sport- & Aktivreise?",
        desc:
          "Mit moverii findest du so einfach wie nie zuvor die passende Sport- & Aktivreise für deine individuellen Wünsche und Bedürfnisse! Dafür empfehlen wir dir deine Suchergebnisse mit unseren Filteroptionen einzugrenzen, um gleich die passende Auswahl angezeigt zu bekommen." +
          "\n" +
          "<br/><br />" +
          "Als Filter stehen dir die folgenden Optionen zur Verfügung:\n" +
          "\n" +
          "<br/>" +
          '<ul class="list-disc2 mx-10 my-4 ">' +
          "<li>Sportarten </li>" +
          "<li>Kategorien innerhalb der Sportarten </li> " +
          "<li>Vorkenntnisse - deine Vorerfahrungen in der jeweiligen Sportart </li>" +
          "<li>Reiseziele - von Kontinenten bis hin zu Regionen und Orten</li>" +
          "<li>Zeitraum - von konkreten Daten bis hin zu ganzen Monaten</li>" +
          "<li> Unterkunft - von Camping bis Luxus, die passende Unterkunft für deine Sport- & Aktivreise </li>" +
          "<li> Verpflegung - von Reisen, bei denen die Verpflegung mit enthalten ist, bis hin zu Ernährungswünschen, wie vegan, vegetarisch oder verbreitete Allergien/ Intoleranzen\n </li>" +
          "<li> Preis pro Nacht - Lege dein Budget für deine Sport- & Aktivreise fest </li>" +
          "</ul>" +
          "\n" +
          "<br/><br />" +
          "\n" +
          "Die verschiedenen Filter findest du auf der linken Seite der " +
          '<Link><a class="contact-hyperlink" href=\'' +
          Routes.search +
          "'>Suchseite</a> </a>" +
          ". Klicke hier einfach auf die Kontrollkästchen der Filteroptionen, die zu dir passen und dir wichtig sind, und du erhältst die passenden Reisen angezeigt." +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/filter-de.png" alt="Screenshot filter search page\n"/>' +
          "Die Alternative zu den Filteroptionen ist unser TripFinder. Wenn du den TripFinder startest, wirst du durch die relevantesten Fragen rund um deine Sport- & Aktivreise geführt und erhältst am Ende passende Empfehlungen. So findest du spielerisch und ohne lange Suche die Sport- & Aktivreise, die zu dir und deinen Wünschen passt!" +
          `<a href="${Routes.tripfinder}" class='font-bold text-black contact-hyperlink'> Zum TripFinder geht es hier entlang. </a> `,
      },
      {
        title: "Was ist der TripFinder?",
        desc:
          "Mit dem TripFinder findest du spielerisch leicht die Sport- & Aktivreise, die zu dir und deinen Wünschen passt! \n" +
          "\n" +
          "<br/>" +
          "<br/>" +
          "Beantworte einfach mit wenigen Klicks die wichtigen Fragen zu deinen Vorstellungen und Rahmenbedingungen und du erhältst von uns passende Empfehlungen für deinen aktiven Traumurlaub. Probier’s am besten einfach selber aus: " +
          "<a href='https://moverii.de/en/tripfinder' class='contact-hyperlink'>Zum TripFinder</a>",
      },
      {
        title: "Wie buche ich meine Reise?",
        desc:
          "Bei den Reisen auf moverii unterscheiden wir zwischen Sofort-Buchungen und Buchungsanfragen. " +
          "\n" +
          "<br/><br />" +
          "Bei <strong>Sofort-Buchungen</strong> handelt es sich um Reisen, wo du die aktuellen Verfügbarkeiten live sehen und dementsprechend deinen Urlaub sofort zu den gewünschten Daten fix buchen kannst." +
          "\n" +
          "<br/><br />" +
          "Bei  <strong>Buchungsanfragen </strong>sind die Verfügbarkeiten nicht aktuell, sondern müssen zunächst von den Gastgeber:innen bestätigt werden." +
          "\n" +
          "<br/><br />" +
          "Ob es sich bei einer Reise um eine Sofort-Buchung oder eine Buchungsanfrage handelt, erkennst du immer an dem Button auf der rechten Seite der Reisebeschreibung." +
          "\n" +
          "<br/><br />" +
          "<h2> Vorgehen bei Sofort-Buchungen\n </h2>\n" +
          "\n" +
          "<br/>" +
          "Wenn es sich um eine Sofort-Buchung handelt, lautet der Text auf dem Button “Zur Buchung”:" +
          "\n" +
          "<br/><br />" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/book-1-de.jpg" alt="Buchung Button\n" />\n' +
          "\n" +
          "<br/><br />" +
          "Um eine Reise mit der Option auf Sofort-Buchung zu buchen, gehst du einfach wie folgt vor:\n" +
          "\n" +
          "<br/>" +
          '<ol class="list-decimal mx-10 my-4">' +
          "<li> Wähle in der Box auf der rechten Seite deinen gewünschten Reisezeitraum und die Anzahl der Gäste aus und klicke auf den Button “Zur Buchung”. .</li> \n" +
          "<li>Jetzt siehst du die Unterkunftsoptionen, die zu dem von dir gewünschten Zeitraum für die von dir ausgewählte Anzahl an Gästen verfügbar ist. Wähle hier einfach die Unterkunft aus, die dich am meisten anspricht.</li> \n" +
          "<li>Wenn die Reisen optionale Leistungen anbietet, kannst du diese im nächsten Schritt deiner Buchung hinzufügen.</li>\n" +
          "<li>m letzten Schritt gibst du deine Daten ein und hast die Möglichkeit zwischen verschiedenen Zahlungsmethoden zu wählen. </li> \n" +
          "<li>Mit deiner (An)zahlung ist deine Buchung bestätigt und du erhältst deine Buchungsbestätigung sowohl per Email, als auch direkt zur Einsicht in deinem moverii Konto. </li> \n" +
          "<li>Unser Tipp: Wenn du dir ein moverii Konto erstellst, erhältst du neben deiner Buchungsbestätigung eine Willkommensnachricht von deinen Gastgeber:innen und hast Zugriff auf weitere nützliche Informationen rund um deinen Urlaub, wie eine Packliste und Informationen zur Anreise.</li>\n" +
          "</ol>" +
          "<br/><br />" +
          "<strong>Vorgehen bei Buchungsanfragen\n</strong>" +
          "Wenn es sich um eine Buchungsanfrage handelt, lautet der Text auf dem Button “Reservieren”:\n" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/book-2-de.jpg" alt="Reservieren Button\n"/>' +
          "" +
          "<br/><br />" +
          '<ol class="list-decimal mx-10 my-4">' +
          "<li> Wähle in der Box auf der rechten Seite deinen gewünschten Reisezeitraum und die Anzahl der Gäste aus und klicke auf den Button “Reservieren”.</li> \n" +
          "<li>Jetzt siehst du alle Unterkunftsoptionen, die die Reise zu bieten hat. Wähle hier die Unterkunft aus, die du dir für deinen Urlaub wünschst.</li> \n" +
          "<li>Wenn die Reisen optionale Leistungen anbietet, kannst du diese im nächsten Schritt deiner Buchungsanfrage hinzufügen.</li>\n" +
          "<li>Im letzten Schritt gibst du deine Daten ein und schickst deine Buchungsanfrage ab.</li> \n" +
          "<li>Eine Antwort auf deine Buchungsanfrage erhältst du immer nach 24 Stunden. Wenn Gastgeber:innen deine Buchungsanfrage bestätigen können, ist die Reise automatisch für dich reserviert.</li> \n" +
          "<li>Um die Reservierung zu bestätigen, stehen dir verschiedene Zahlungsmethoden zur Verfügung. Sobald die Zahlung bei uns eingegangen ist, erhältst du deine Buchungsbestätigung sowohl per Email, als auch direkt zur Einsicht in deinem moverii Konto.  </li> \n" +
          "<li>Unser Tipp: Wenn du dir ein moverii Konto erstellst, erhältst du neben deiner Buchungsbestätigung eine Willkommensnachricht von deinen Gastgeber:innen und hast Zugriff auf weitere nützliche Informationen rund um deinen Urlaub, wie eine Packliste und Informationen zur Anreise.</li>\n" +
          "</ol>" +
          "",
      },
      {
        title: "Wie nehme ich Kontakt zu Gastgeber:innen auf?\n",
        desc:
          "Um die Gastgeber:innen der Reisen zu kontaktieren, kannst du einfach auf den Button “Gastgeber:in kontaktieren” in der Box auf der rechten Seite klicken:" +
          "\n" +
          "<br/><br />" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/contact-host-1-de.png" class="my-10" alt="Gastgeber:in kontaktieren Button\n"/>\n' +
          "Anschließend öffnet sich ein Fenster, in dem du eine Nachricht mit deinen Fragen und Wünschen an den/die Gastgeber:in schreiben kannst: " +
          "\n" +
          "<br/><br />" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/contact-host-2-de.png" class="my-10" alt="Pop-up Kontaktanfrage"/> \n' +
          "\n" +
          "\n" +
          "<br/><br />" +
          "Wenn du schon weißt, wann und mit wem du verreisen willst, hast du zudem die Möglichkeit, deinen gewünschten Reisezeitraum, die Anzahl der Reisenden und deine bevorzugte Zimmerkategorie anzugeben. Dafür kannst du einfach das Kontrollkästchen “Ich weiß schon, wann und mit wem ich verreisen will” anklicken:" +
          "\n" +
          "\n" +
          "<br/><br />" +
          ' <img src="https://api.moverii.de/cdn/statics/contact_help/contact-host-3-de.png" class="my-10" alt="Pop-up Kontaktanfrage mit geöffnetem \n"/>\n' +
          "\n" +
          "<br/><br />" +
          "Eine Antwort der Gastgeber:innen erhältst du in der Regel immer innerhalb von 24 Stunden. \n",
      },
      {
        title: "Kann ich Reisen reservieren?\n",
        desc:
          "Bei Buchungsanfragen ist die Reise nach der Bestätigung der Verfügbarkeit durch die Gastgeber:in automatisch für dich reserviert. In der Regel ist die Reservierung für 48 Stunden gültig. " +
          "\n" +
          "<br/><br />" +
          "Die Mindestdauer einer Reservierung liegt bei 24 Stunden. Diese verkürzte Zeit der Reservierung kann bei kurzfristigen Anfragen, wenn es um die letzten Plätze geht, aufkommen. \n" +
          "\n" +
          "<br/><br />" +
          "Wenn du bei deiner Urlaubsplanung nicht zu spontan unterwegs bist, reservieren Gastgeber:innen deine Reise auch gerne länger für dich. Dafür kannst du einfach Kontakt zu dem/der Gastgeber:in aufnehmen. \n" +
          "\n" +
          "<br/><br />" +
          "Wie lange die Reise für dich reserviert ist, siehst du immer in der Email mit der Bestätigung und einem moverii Konto unter dem Menüpunkt “Deine Reisen”.\n",
      },
      {
        title: "Wie sehe ich die Verfügbarkeiten für die Reisen?\n",
        desc:
          "Bei den Reisen auf moverii unterscheiden wir zwischen Sofort-Buchungen und Buchungsanfragen. " +
          "\n" +
          "<br/><br />" +
          "Bei Sofort-Buchungen handelt es sich um Reisen, wo du die aktuellen Verfügbarkeiten live sehen kannst. Gib dafür einfach in der Box auf der rechten Seite der Reisebeschreibung deinen gewünschten Zeitraum und die Anzahl der Reisenden an und klicke auf den Button “Zur Buchung”. Anschließend siehst du die verfügbaren Unterkunftsoptionen zu dem von dir gewünschten Zeitraum und kannst deinen Urlaub sofort zu den gewünschten Daten fix buchen.\n" +
          "\n" +
          "<br/><br />" +
          "Bei Buchungsanfragen sind die Verfügbarkeiten nicht aktuell, sondern müssen zunächst von den Gastgeber:innen bestätigt werden. Dafür kannst du einfach eine Buchungsanfrage stellen. Gib dafür einfach in der Box auf der rechten Seite der Reisebeschreibung deinen gewünschten Zeitraum und die Anzahl der Reisenden an und klicke auf den Button “Reservieren”. Anschließend kannst du die von dir gewünschte Unterkunftsoption auswählen und optionale Leistungen deiner Buchungsanfrage hinzufügen. Eine Antwort auf deine Buchungsanfrage erhältst du innerhalb von 24 Stunden. Wenn die von dir gewünschte Reise so in der Form nicht mehr verfügbar ist, erhältst du sowohl von uns, als auch von dem/der Gastgeber:in passende Alternativvorschläge.\n",
      },
      {
        title: "Kann ich die Reisedauer individuell anpassen?\n",
        desc:
          "Reisen auf moverii verfolgen einen ganzheitlichen Ansatz und bestehen immer mindestens aus der Kombination aus einer Unterkunft und dem Sport- & Aktivprogramm. Bei vielen Reisen kommen weitere Leistungen, wie die Verpflegung, weitere Aktivitäten oder gemeinsame Ausflüge mit hinzu. Die verschiedenen Erlebnisse bauen häufig aufeinander auf und daraus entstehen Reisepakete mit einer bestimmten Dauer." +
          "\n" +
          "<br/><br />" +
          "Die genaue Dauer variiert von Reise zu Reise und hängt von den Erfahrungen und dem Programm ab. Dabei bieten einige Reisen auch mehrere Optionen zur Auswahl. Die jeweiligen Optionen siehst du immer in den Fakten zu der Reise:" +
          "\n" +
          "<br/><br />" +
          "\n" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/duration.jpg" alt="Kann ich die Reisedauer individuell anpassen?"/>\n' +
          "\n" +
          "<br/><br />" +
          "Wenn du dir eine andere Reisedauer als angegeben wünschst, kannst du immer die Gastgeber:innen kontaktieren und deinen gewünschten Reisezeitraum mitteilen. In den vielen Fällen können Gastgeber:innen dir ein individuelles Angebot machen. \n" +
          "\n" +
          "<br/><br />" +
          "Mehr Infos zum Thema Reisedauer und wie flexibel diese ausgelegt werden kann, findest du zudem in den FAQs der jeweiligen Reisen.\n",
      },
      {
        title: "Kann ich Leistungen hinzufügen / entfernen?\n",
        desc: "Bei Reisen auf moverii sind immer mindestens die Unterkunft und das Sport- & Aktivprogramm als Leistungen mit im Preis enthalten. Je nach Reise können weitere Leistungen, wie die Verpflegung, weitere Aktivitäten oder gemeinsame Ausflüge ebenfalls mit im Preis enthalten sein. Zudem hast du bei vielen Reisen die Möglichkeit, Leistungen optional mit dazu zu buchen. Wenn du darüber hinaus individuelle Wünsche hast, kannst du einfach Kontakt zu den Gastgeber:innen aufnehmen und sie geben ihr bestes, um dir ein individuelles Angebot zu erstellen.\n",
      },
      {
        title: "Buchungsbestätigung und Reiseinformationen\n",
        desc:
          "Sobald du deine Buchung bestätigt hast, erhältst du deine Buchungsbestätigung im pdf-Format sowohl per Email als auch in deinem moverii Konto zum Herunterladen. Die Buchungsbestätigung enthält alle Eckdaten deiner Reise, sowie die Daten der Reisenden und eine Übersicht der im Preis enthaltenen Leistungen.\n" +
          "\n" +
          "<br/><br />" +
          "Neben deiner Buchungsbestätigung, erhältst du eine Willkommensnachricht deiner Gastgeber:in mit allen wichtigen Infos rund um deine Reise. Auf diese Nachricht kannst du zu jeder Zeit in deinem moverii Konto unter dem Menüpunkt “Meine Reisen” zugreifen. Hier findest du auch weitere Informationen, wie eine Packliste, Details zu deiner Anreise und die Check-in Zeiten. Wenn du darüber hinaus noch Fragen haben solltest, freuen sich deine Gastgeber:innen immer auf eine Antwort auf die Willkommensnachricht und stehen dir jederzeit zur Seite. \n" +
          "\n" +
          "<br/><br />" +
          "Wenn du allgemeine Fragen oder Wünsche hast, kannst du dich natürlich auch immer an dein moverii Team wenden und uns eine Nachricht schreiben. Wir antworten dir garantiert innerhalb von wenigen Stunden.\n",
      },
    ],
  },
  {
    title: "Anreise und Verpflegung",
    desc: [
      {
        title: "Kann ich die Anreise über moverii buchen?",
        desc:
          "Bis auf wenige Ausnahmen bist du bei Reisen auf moverii für die An- und Abreise selber verantwortlich. Die Ausnahme bilden einige wenige Reisen innerhalb von Europa. \n" +
          "\n" +
          "<br/><br />" +
          "Informationen zur Anreise findest du immer im Abschnitt “Anreise” in der Reisebeschreibung. Hier erfährst du auch Tipps, wie du am besten zu deinem Reiseziel gelangst. \n" +
          "\n" +
          "<br/><br />" +
          "Zudem bieten viele Gastgeber:innen einen Flughafentransfer an, der entweder schon im Reisepaket mit enthalten ist oder aber optional mit dazu gebucht werden kann.\n" +
          "\n" +
          "<br/><br />" +
          "Grundsätzlich empfehlen wir dir für die Suche nach passenden Flügen Skyscanner. Wenn du mit dem Zug oder dem Bus anreisen willst, findest du bei Trainline das passende Angebot.\n",
      },
      {
        title: "Gibt es Transfers vom Flughafen / Bahnhof?",
        desc:
          "Bei vielen Reisen wird ein Transfer vom Flughafen oder Bahnhof angeboten. Teilweise sind diese schon im Reisepaket mit enthalten oder können alternativ optional mit dazu gebucht werden.\n" +
          "\n" +
          "<br/><br />" +
          "Wenn kein Transfer angeboten wird, gibt dir dein:e Gastgeber:in gerne Tipps für den besten Weg oder den Kontakt zu einem Shuttle Service.\n" +
          "\n" +
          "<br/><br />" +
          "Vor deiner Buchung findest du Informationen zur Anreise immer im Abschnitt “Anreise” in der Reisebeschreibung. Sobald du deine Reise gebucht hast, findest du weitere Informationen in deinem moverii Konto unter dem Menüpunkt “Meine Reisen”.\n",
      },
      {
        title:
          "Wie erkenne ich meine:n Fahrer:in bei Flughafen-/ Bahnhoftransfers?\n",
        desc: "Wenn du für deine Reise einen Transfer gebucht hast, erhältst du neben der Buchungsbestätigung eine Willkommensnachricht deiner Gastgeber:in sowie weitere Informationen rund um deine Reise. Darunter auch detaillierte Informationen zu deiner Anreise und deinem Flughafentransfer. Diese Informationen findest du in deinem moverii Konto unter dem Menüpunkt “Meine Reisen”.\n",
      },
      {
        title: "Wann sind die Check-in und Check-out Zeiten?\n",
        desc: "Die Check-in und Check-out Zeiten variieren von Reise zu Reise. Die entsprechende Information dazu findest du sowohl in den FAQs der Reisebeschreibung, als auch im Anschluss deiner Buchung in deinem moverii Konto unter dem Menüpunkt “Meine Reisen”. Neben den Check-in und Check-out Zeiten siehst du hier auch, ob du schon früher anreisen, dein Gepäck verstauen und die Gemeinschaftsbereiche nutzen kannst.",
      },
      {
        title: "Ist die Verpflegung im Preis enthalten?\n",
        desc:
          "Ob die Verpflegung im Reisepaket mit enthalten ist, variiert von Reise zu Reise: Du findest auf moverii sowohl Reisen, bei denen du die volle Verpflegung mit dabei hast, als auch Reisen, bei denen das Frühstück inklusive ist. Wiederum andere Reisen bieten dir die Möglichkeit, die Verpflegung optional mit dazu zu buchen. Wenn du lieber selber kochen willst, findest auf moverii ebenfalls Reisen ohne Verpflegung, dafür aber mit einer Küche, die du nutzen kannst. Sei es eine Gemeinschaftsküche oder die eigene Küche in einem Apartment. \n" +
          "\n" +
          "<br/><br />" +
          "Wenn du dir für deine Reise wünschst, dass die Verpflegung im Reisepaket mit enthalten ist, kannst du deine Suchergebnisse einfach mit den Filteroptionen “Volle Verpflegung” / “Inklusive Frühstück” eingrenzen. \n" +
          "\n" +
          "<br/><br />" +
          "Ob die Verpflegung mit im Reisepaket enthalten ist und wie sich diese gestaltet, erfährst du immer im Abschnitt “Verpflegung” der jeweiligen Reisebeschreibungen. \n" +
          "\n" +
          "<br/><br />" +
          "Auf Ernährungswünsche und Allergien nehmen deine Gastgeber:innen gerne Rücksicht! Gib diese bitte einfach bei deiner Buchung an. Zudem hast du bei der Suche nach der passenden Reise direkt die Möglichkeit nach deinen Ernährungswünschen zu filtern. Nutze dafür einfach die Filter “Vegetarisch”, “Vegan”, “Rohkost”, “Laktosefrei” und “Glutenfrei”.\n",
      },
      {
        title: "Gibt es Reisen mit veganer / vegetarischer Verpflegung?\n",
        desc:
          "Bei den meisten Reisen wird vegetarische und vegane Verpflegung mit angeboten. Um sicher zu gehen, kannst du bei der Suche nach der passenden Reise einfach den Filter “Vegetarisch” und / oder “Vegan” in der Kategorie Verpflegung anklicken und dir werden nur Reisen mit vegetarische und / oder veganer Verpflegung angezeigt.\n" +
          "\n" +
          "<br/><br />" +
          "Wenn die Verpflegung mit im Reisepaket enthalten ist, werden deine Ernährungswünsche in der Regel schon bei der Buchung abgefragt. Alternativ kannst du dafür immer die Box “Deine Wünsche” im letzten Schritt deiner Buchung nutzen.\n",
      },
      {
        title:
          "Was kann ich machen, wenn ich besondere Ernährungswünsche oder Allergien habe?",
        desc:
          "Je nach dem wie spezifisch deine Ernährungswünsche sind, kannst du schon bei der Suche nach der passenden Reise deine Auswahl eingrenzen. Nutze dafür einfach die Filter “Vegetarisch”, “Vegan”, “Rohkost”, “Laktosefrei” und “Glutenfrei” in der Kategorie “Verpflegung”.\n" +
          "\n" +
          "<br/><br />" +
          "Wenn du spezifischere Ernährungswünsche hast, kannst du diese einfach bei deiner Buchung im letzten Schritt in der Box “Deine Wünsche” angeben. Alternativ kannst du deinen Gastgeber:innen auch einfach eine Nachricht schreiben.\n",
      },
    ],
  },
  {
    title: "Bezahlung",
    desc: [
      {
        title: "Welche Zahlungsmethoden stehen mir zur Auswahl?\n",
        desc:
          "Ein Vorteil bei einer Reisebuchung mit moverii ist, dass du sicher Online bezahlen kannst. Dabei kannst du entscheiden, ob du bei deiner Buchung den gesamten Betrag bezahlst oder zunächst eine Anzahlung tätigst. \n" +
          "\n" +
          "<br/><br />" +
          "Bei einer Anzahlung werden 25% des Gesamtbetrages zum Zeitpunkt der Buchung fällig. Die restlichen 75% bitten wir dich bis 30 Tage vor Reiseantritt zu begleichen. \n" +
          "\n" +
          "<br/><br />" +
          "Ganz gleich ob du dich für eine vollständige Zahlung oder eine Anzahlung - Restzahlung entscheidest, die folgenden Zahlungsmethoden stehen dir dafür zur Verfügung: \n" +
          '<ul class="list-disc mx-10 my-4">' +
          '<li><span class="text-2xl">&#8226;</span> Kredit- oder Debitkarte (VISA, Mastercard, Maestro, American Express, JCB, Discover und Bancontact)</li> \n' +
          '<li><span class="text-2xl">&#8226;</span> PayPal</li> \n' +
          '<li><span class="text-2xl">&#8226;</span> GooglePay</li> \n' +
          '<li><span class="text-2xl">&#8226;</span> ApplePay</li> \n' +
          '<li><span class="text-2xl">&#8226;</span> Klarna</li> \n' +
          '<li><span class="text-2xl">&#8226;</span> Sofortüberweisung</li> \n' +
          "</ul>",
      },
      {
        title: "Wie funktioniert die Anzahlung - Restzahlung?",
        desc:
          "Wenn du dich bei deiner Buchung für eine Anzahlung - Restzahlung entscheidest, zahlst du zunächst nur 25% des Gesamtbetrages, um deine Buchung zu bestätigen. \n" +
          "\n" +
          "<br/><br />" +
          "Die restlichen 75% des Gesamtbetrages bitten wir dich bis 30 Tage vor Reiseantritt zu begleichen. Dafür erhältst du eine separate Email mit deiner Rechnung und der Möglichkeit diese mit deiner gewählten Zahlungsmethode zu bezahlen.\n",
      },
      {
        title: "Was steckt hinter der Bestpreisgarantie?",
        desc:
          "Wir garantieren dir bei all unseren Reisen den besten Preis! Das bedeutet, dass du die gleiche Reise nirgendwo preiswerter buchen kannst. \n" +
          "\n" +
          "<br/><br />" +
          "Wenn du genau die gleiche Reise zu den identischen Daten auf einer anderen Webseite preiswerter findest, erstatten wir dir die Differenz! Dafür kannst du uns einfach eine Nachricht mit einem Screenshot schicken. Ausgenommen sind spezielle Rabattaktionen anderer Webseiten.\n",
      },
      {
        title: "Was kann ich bei Problemen mit der Zahlung machen?",
        desc:
          "Wenn bei der Zahlung deiner Reise Probleme auftreten, versuche zunächst bitte Folgendes:\n" +
          "\n" +
          "<br/><br />" +
          '<ol class="mx-10 my-4 disc-list-contact">' +
          "<li>Überprüfe noch einmal, ob du all deine Zahlungsdaten korrekt eingegeben hast, und versuche es erneut.</li> \n" +
          "<li>Falls du versuchst, mit einer Kredit- oder Debitkarte zu zahlen, vergewissere dich bitte, dass deine Karte sowohl für internationale als auch für Online-Einkäufe autorisiert ist. Du kannst dies entweder in deinen Online-Banking-Einstellungen nachlesen oder dich direkt an deine Bank wenden.</li> \n" +
          "<li>Wenn keine Fehlermeldung angezeigt wurde, versuche es mit einem anderen Browser. </li>  \n" +
          "<li>Falls du immernoch Probleme bei der Durchführung deiner Zahlung hast, wähle bitte eine andere Zahlungsmethode.</li> \n" +
          "\n" +
          "\n" +
          "</ol>" +
          "<br/><br />" +
          "Wenn du alleine nicht weiter kommst und die Zahlung nicht durchführen kannst, schreib uns gerne eine Nachricht mit deinem Problem und wir finden gemeinsam eine Lösung:" +
          "\n" +
          "<br/>" +
          "Integration Kontaktform (Name, Email-Adresse, optional Telefonnummer, Nachricht)",
      },
      {
        title: "Kann ich einen Geschenkgutschein kaufen?",
        desc:
          "Mit einem Geschenkgutschein für moverii verschenkt du Erlebnisse für die Ewigkeit! Um einen Geschenkgutschein zu kaufen, kannst du einfach wie folgt vorgehen:" +
          "\n" +
          "<br/>" +
          '<ol class="list-decimal mx-10 my-4">' +
          "<li>Gehe auf die folgende Webseite: moverii Geschenkgutscheine</li> \n" +
          "<li> Wähle das von dir bevorzugte Design</li>\n" +
          "<li>Individualisiere deinen Gutschein mit einem persönlichen Text</li> \n" +
          "<li>Wähle den Betrag, den du verschenken möchtest</li> \n" +
          "<li>Entscheide, ob du den Geschenkgutschein ausdrucken und verschenken willst oder dieser zu einem bestimmten Datum per E-Mail verschickt werden soll</li> \n" +
          "<li>Führe deine Zahlung durch und Zauber deinen Liebsten ein Lächeln auf's Gesicht</li> \n" +
          "</ol>" +
          "\n" +
          "\n" +
          "<br/><br />" +
          "Grundsätzlich können Geschenkgutscheine für alle Reisen auf moverii eingelöst werden. Es gibt auch kein Ablaufdatum, wann der Gutschein verfällt.\n" +
          'Alle Informationen zu unserem Geschenkgutschein, sowie die Möglichkeit zum Kauf findest du hier: <a href="https://moverii.de/voucher">Zum moverii Geschenkgutschein</a>\n',
      },
      {
        title: "Wie löse ich einen Gutschein ein?\n",
        desc: "Jeder moverii Gutschein enthält einen Code. Um deinen Gutschein einzulösen, kannst du einfach den Buchungsprozess für deine gewünschte Reise starten und im letzten Schritt unter dem Punkt “Gutschein einlösen” deinen Gutscheincode eingeben. Anschließend wird der Wert des Gutscheins automatisch vom Gesamtbetrag abgezogen.\n",
      },
    ],
  },
  {
    title: "Stornierung",
    desc: [
      {
        title:
          "Welche Stornierungsbedingungen gelten für Reisen auf moverii?\n",
        desc:
          "Für die Stornierungsbedingungen auf moverii haben wir vier einheitliche Stufen definiert und alle Reisen auf unserer Webseite in diese vier Stufen einsortiert. Somit können wir dir maximale Transparenz bieten und du kannst den Großteil der Reisen ohne Angabe von Gründen kostenfrei stornieren. \n" +
          "\n" +
          "<br/><br />" +
          "Hier sind die vier Stufen unserer Stornierungsbedingungen:\n" +
          "\n" +
          "<br/>" +
          "<strong> Sehr flexibel </strong>\n" +
          "<br/>" +
          '<ol class="list-disc m-4 ml-10 disc-list-contact">' +
          "<li>100% Rückerstattung des Gesamtbetrages bei einer Stornierung bis 7 oder mehr Tagen vor Antritt der Reise</li> \n" +
          "<li>Keine Rückerstattung bei einer Stornierung ab 6 Tagen vor Antritt der Reise</li> \n" +
          "</ol>" +
          "\n" +
          "\n" +
          "<br/><br />" +
          "<strong>Flexibel </strong> \n" +
          "<br/>" +
          '<ol class="list-disc m-4 ml-10 disc-list-contact">' +
          " <li>100% Rückerstattung des Gesamtbetrages bei einer Stornierung bis 30 oder mehr Tagen vor Antritt der Reise</li> \n" +
          "<li>50% Rückerstattung des Gesamtbetrages bei einer Stornierung zwischen 15-29 Tagen vor Antritt der Reise </li> \n" +
          "<li>Keine Rückerstattung bei einer Stornierung ab 14 Tage vor Antritt der Reise</li> \n" +
          "</ol>" +
          "\n" +
          "<br/><br />" +
          "\n" +
          "<strong>Moderat </strong> \n" +
          "<br/>" +
          '<ol class="list-disc m-4 ml-10 disc-list-contact">' +
          "<li>100% Rückerstattung des Gesamtbetrages bei einer Stornierung bis 60 oder mehr Tagen vor Antritt der Reise </li> \n" +
          "<li> 50% Rückerstattung des Gesamtbetrages bei einer Stornierung zwischen 30-59 Tagen vor Antritt der Reise</li>\n" +
          "<li>Keine Rückerstattung bei einer Stornierung ab 29 Tage vor Antritt der Reise </li> \n" +
          "</ol>" +
          "\n" +
          "<br/><br />" +
          "\n" +
          "<strong>Individual</strong> \n" +
          "<br/>" +
          '<ol class="list-disc m-4 ml-10 disc-list-contact">' +
          "<li> Individuell bedeutet, dass die Stornierungsbedingungen von den Gastgeber:innen selber festgelegt sind, da es uns leider nicht ganz möglich ist, für alle Reisen eine passende Stufe zu finden. Individuelle Stornierungsbedingungen sind jedoch die Ausnahme und dennoch leicht verständlich aufbereitet.</li> \n" +
          "</ol>" +
          "<br/><br />" +
          "\n" +
          "Welche Stufe für die einzelnen Reisen gilt, siehst du immer in der Reisebeschreibung in den Fakten zu der Reise:" +
          "\n" +
          "<br/><br />" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/cancel-de.jpg" alt="Welche Stornierungsbedingungen gelten für Reisen auf moverii?" /> \n' +
          "\n" +
          "<br/><br />" +
          "Wenn du nur Reisen mit (sehr) flexiblen Stornierungsbedingungen angezeigt bekommen willst, kannst du bei deiner Suche einfach den entsprechenden Filter “Stornierungsbedingungen” nutzen.\n" +
          "\n" +
          "<br/><br />" +
          'ehr Informationen zu unseren Stornierungsbedingungen findest du hier: <a href="https://www.moverii.de/content/cancellation">Stornierungsbedingungen bei moverii</a>  \n' +
          "\n" +
          "<br/><br />" +
          'Alle Reisen mit (sehr) flexiblen Stornierungsbedingungen findest du hier: <a href="https://moverii.de/s/moverii?page=1&cancel[]=1">Zu allen Reisen mit (sehr) flexiblen Stornierungsbedingungen</a>\n',
      },
      {
        title: "Kann ich meine Reise auf ein anderes Datum umbuchen?\n",
        desc:
          "Neben einer Stornierung hast du bei vielen Reisen auf moverii zusätzlich die Möglichkeit deinen Urlaub auf einen späteren Zeitpunkt umzubuchen. Die Umbuchung kann dabei in vielen Fällen deutlich später als die Stornierung mit vollständiger Rückerstattung vorgenommen werden. " +
          "\n" +
          "<br/><br />" +
          "Ob und bis wann du eine Reise kostenfrei umbuchen kannst, siehst du immer in den Fakten zu der Reise:" +
          "\n" +
          "\n" +
          "<br/><br />" +
          '<img src="https://api.moverii.de/cdn/statics/contact_help/date-change.jpg" alt="facts about the trip - pop-up cancellation conditions" />' +
          "\n" +
          "<br/><br />" +
          "Wenn du deine Reise umbuchen willst, kannst du deinen Gastgeber:innen einfach eine Nachricht schreiben.\n",
      },
      {
        title: "Wie storniere ich meine Buchung?",
        desc:
          "Wenn du deine Buchung stornieren willst, kannst du das ganz einfach in deinem moverii-Konto machen. Gehe dafür wie folgt vor:\n" +
          "\n" +
          "<br/>" +
          '<ol class="list-decimal mx-10 my-4">' +
          "<li>Klick im Menü auf “Meine Reisen” und du gelangst zur Übersichtsseite deiner Buchung. </li> \n" +
          "<li> In dem Abschnitt “Übersicht deiner Reise” findest du den Punkt Stornierungsbedingungen. Klicke hier auf “Mehr erfahren”. </li> \n" +
          "<li>Jetzt öffnet sich ein Pop-up, in dem du nochmal detailliert aufgelistet bekommst, welcher Betrag bis wann erstattet wird.   </li> \n" +
          "<li>Wenn du dich final dazu entscheidest, die Reise zu stornieren, klicke auf den Button “Jetzt stornieren” und die Buchung wird automatisch storniert und die Rückerstattung angewiesen. </li> \n" +
          "<li>Im letzten Schritt erhältst du eine Stornierungsbestätigung und der erstattungsfähige Betrag wird dir innerhalb von wenigen Tagen wieder auf die von die gewählte Zahlungsmethode gutgeschrieben.</li> \n" +
          "</ol>" +
          "\n" +
          "\n" +
          "<br/><br />" +
          "Unser Tipp: Bevor du eine Reise stornierst, kannst du vorab immer Kontakt zu den Gastgeber:innen aufnehmen. In vielen Fällen findet ihr gemeinsam eine noch bessere Lösung.\n",
      },
      {
        title:
          "Wann erhalte ich meine Stornierungsbestätigung und die Rückerstattung des fälligen Betrages?",
        desc:
          "Wenn du deine Buchung stornierst, erhältst du sofort deine Stornierungsbestätigung. Auch die Rückerstattung wird in dem Moment automatisch angewiesen. \n" +
          "\n" +
          "<br/><br />" +
          "Die Rückerstattung erfolgt immer automatisch mit der gleichen Zahlungsmethode, die du auch für deine Buchung gewählt hast. Abhängig davon trifft die Rückerstattung entweder sofort oder maximal innerhalb von 3 Werktagen bei dir ein. Du musst also nichts weiter machen.\n",
      },
      {
        title:
          "Brauche ich für eine Sport- & Aktivreise eine Reiseversicherung?",
        desc:
          "Damit du deinen Urlaub in vollen Zügen und ohne jegliche Sorgen genießen kannst, empfehlen wir dir einen entsprechenden Reiseschutz. \n" +
          "\n" +
          "<br/><br />" +
          "An allererster Stelle steht dabei für uns eine Auslandskrankenversicherung, damit du im Fall der Fälle eine bestmögliche Behandlung erhältst ohne dadurch immense Kosten selber tragen zu müssen. \n" +
          "\n" +
          "<br/><br />" +
          "Ebenfalls empfehlen wir dir den Abschluss einer Reiserücktritts- und Reiseabbruchversicherung. So bist du unabhängig von den Stornierungsbedingungen  umfassend abgesichert und erhältst auch kurzfristig und vor Ort immer alle Kosten zu 100% zurückerstattet. Das gilt neben Corona bedingten Umständen auch für viele weitere Gründe, wie andere Krankheiten, schwere Unfälle, der Verlust des Arbeitsplatzes und vieles mehr. \n" +
          "\n" +
          "<br/><br />" +
          'Um dir das Leben bei der Suche nach dem besten Reiseschutz so einfach wie möglich zu machen, arbeiten wir mit Travelsecure, dem mehrfachen Testsieher von Stiftung Warentest zusammen. Alle Informationen zu Travelsecure und die Möglichkeit deine Reiseversicherung abzuschließen findest du hier: Deine Reiseversicherung mit <a href="https://rechner.travelsecure.de/schnellerfassung/default.aspx?partnerid=1-8-4975">Travelsecure</a>\n',
      },
    ],
  },
];
export { contactEnData, contactDeData };
